import { createSlice } from '@reduxjs/toolkit';

import workerInitialState from './initialState';
import reducers from './reducers';

const workerSlice = createSlice({
  name: '@worker',
  initialState: workerInitialState,
  reducers,
});

export const workerActions = workerSlice.actions;
export const workerReducers = workerSlice.reducer;
